import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma inmediata para que puedas empezar a usarlo hoy mismo, sin esperas ni trámites.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'El Mega Pack está diseñado para docentes de secundaria y bachillerato que enseñan Ciencias de la Salud, Biología, Educación para la Salud o materias afines. El lenguaje y las actividades están calibrados para adolescentes de 12 a 18 años.'
}, {
  q: '¿Sirve para cualquier país hispanohablante?',
  a: 'Sí. El contenido usa español neutro latinoamericano sin regionalismos y está alineado con los estándares internacionales de la OMS y la UNESCO reconocidos por los Ministerios de Educación de toda la región. El material es igualmente válido en Argentina, Chile, México, Colombia, Perú, Uruguay, Bolivia, Paraguay, Ecuador, Honduras, Guatemala, El Salvador, Nicaragua, Costa Rica y República Dominicana.'
}, {
  q: '¿El material es editable?',
  a: 'El material se entrega en formato PDF de alta calidad listo para imprimir o proyectar. El formato PDF garantiza que el diseño se vea exactamente igual en cualquier dispositivo y en cualquier impresora.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagás en tu moneda local. El sistema detecta automáticamente tu país y convierte el precio al equivalente en tu moneda. Sin sorpresas ni conversiones manuales.'
}, {
  q: '¿Qué incluye la oferta de USD 27,90?',
  a: 'Incluye todo el Mega Pack Ciencias de la Salud en el Aula (4 tomos + 4 bonos) más el Pack Maestro Avanzado completo: el Manual de Primeros Auxilios y Emergencias Médicas Escolares, la guía de Neurociencia, Salud Mental y Adicciones en la Generación Alpha, y el Laboratorio de Casos Clínicos y Evaluación por Competencias. Es el sistema completo para el docente que quiere estar preparado para cualquier situación dentro y fuera del aula.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si por cualquier razón el material no cumple tus expectativas te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-green-dark" data-id="element-82">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-green-emerald/15 rounded-xl overflow-hidden shadow-sm" data-id="element-84">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85">
                <span className="font-bold text-lg text-ink pr-8" data-id="element-86">{faq.q}</span>
                <ChevronDown className={`text-green-emerald transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" />
              </button>

              <AnimatePresence data-id="element-88">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89">
                    <div className="px-6 pb-5 text-ink-muted border-t border-green-emerald/10 pt-4" data-id="element-90">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}